"use strict";

import dataLayerService from "../../Shared/datalayer-service.js";

/*
 * Fires the ai_search_open GA4 event when the user opens the AI Travel Agent.
 *
 * The entry points are plain anchors that navigate away: the "Search with AI" CTA in the
 * header/homepage (ai-search-iglu variant B) and the "Try our new AI Travel Agent" link in the
 * search results banner. The push runs on click, before the browser leaves the page.
 *
 * Event payload:
 *   visitor_id       the visitor id from its cookie, or "" when the cookie is not set
 *   page_location    the full URL the user opened the AI Travel Agent from
 *   is_first_ai_use  true the first time this browser opens it, false after that
 */
const searchWithAiTracking = (() => {
    const FIRST_USE_STORAGE_KEY = "aiSearchOpened";

    // Elements that open the AI Travel Agent. The banner's link is the anchor, not the <p>.
    const ENTRY_POINT_SELECTORS = [
        "#search-with-ai-cta",
        "#search-with-ai-banner a"
    ];

    /*
     * Return true the first time this browser opens the AI Travel Agent, then false.
     * A read or write can throw when storage is blocked or full. Treat any failure as "not
     * the first use" so tracking never stops the link from working.
     */
    const resolveIsFirstUse = () => {
        try {
            if (window.localStorage.getItem(FIRST_USE_STORAGE_KEY) === "true") {
                return false;
            }

            window.localStorage.setItem(FIRST_USE_STORAGE_KEY, "true");
            return true;
        } catch (error) {
            return false;
        }
    };

    const trackOpen = () => {
        dataLayerService.pushEventWithData(dataLayerService.EVENTS.AI_SEARCH_OPEN, {
            visitor_id: dataLayerService.getVisitorId(),
            page_location: window.location.href,
            is_first_ai_use: resolveIsFirstUse()
        });
    };

    const init = () => {
        const entryPoints = document.querySelectorAll(ENTRY_POINT_SELECTORS.join(", "));

        entryPoints.forEach((entryPoint) => {
            entryPoint.addEventListener("click", trackOpen);
        });
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }

    return {
        init,
        trackOpen
    };
})();

export default searchWithAiTracking;
